import { publicConfig } from './config';

let initialized = false;
const ASSESSMENT_RESULT_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function currentAssessmentResultId() {
  try {
    const direct = window.sessionStorage.getItem('orivon_active_assessment_id_v1');
    if (direct && ASSESSMENT_RESULT_ID.test(direct)) return direct;
    for (const [storage, key] of [
      [window.sessionStorage, 'orivon_assessment_draft_v1'],
      [window.localStorage, 'orivon_assessment_handoff_v1'],
      [window.localStorage, 'orivon_professional_profile_v1']
    ] as const) {
      const raw = storage.getItem(key);
      if (!raw) continue;
      const id = (JSON.parse(raw) as { assessmentResultId?: unknown }).assessmentResultId;
      if (typeof id === 'string' && ASSESSMENT_RESULT_ID.test(id)) return id;
    }
  } catch {
    // Analytics correlation must never make storage a product dependency.
  }
  return null;
}

export async function initializeAnalytics() {
  if (initialized || window.posthog?.capture) return;
  const config = publicConfig();
  if (!config.posthogProjectKey) return;
  initialized = true;
  try {
    const { default: posthog } = await import('posthog-js');
    posthog.init(config.posthogProjectKey, {
      api_host: config.posthogHost,
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      opt_out_capturing_by_default:
        !window.OrivonConsent?.analyticsGranted(),
      respect_dnt: true
    });
    window.posthog = posthog;
    window.OrivonConsent?.syncAnalytics();
  } catch {
    initialized = false;
  }
}

export function track(event: string, properties: Record<string, unknown> = {}) {
  try {
    const assessmentResultId = currentAssessmentResultId();
    window.posthog?.capture?.(event, {
      surface: 'app',
      ...properties,
      ...(assessmentResultId ? { assessment_result_id: assessmentResultId } : {})
    });
  } catch {
    // Analytics must never block the product.
  }
}
